class ArticleContent extends HTMLElement {
  constructor() {
    super();

    const articleId = this.getAttribute('data-article-id');
    articleId && this.trackViews(articleId);

    this.selectors = {
      table: 'table',
    };

    this.createTableContainer();
  }

  trackViews(id) {
    fetch(`https://ald-app-1.aldkeetchen.com/api/view/${id}`);
  }

  createTableContainer() {
    this.tables = this.querySelectorAll(this.selectors.table);

    this.tables.forEach(table => {
      const container = document.createElement('div');
      container.setAttribute('class', 'table-container');

      table.before(container);
      container.append(table);
    });
  }
}

customElements.define('article-content', ArticleContent);
